import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const AlarmHistoryPage = withSuspense(
	lazy(async () => await import('./alarm-history-page.component')),
	PageLoader,
);
